import React from 'react';
import c from 'classnames';
import { IconSize } from '../../../../Icons/IconWrap';
import commonStyles from '../../common.scss';
import s from './ListItemContent.scss';
const ListItemContent = ({ prefix, prefixIcon: PrefixIcon, label, subLabel, suffix, suffixIcon: SuffixIcon, bottomSlot, isLabelBold, isDim, isDangerous, biggerPaddings, onClick })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], isDim && s['dim'], isDangerous && s['dangerous'], biggerPaddings && s['padded']),
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['main-content-grid'], prefix && s['has-prefix'])
    }, (prefix || PrefixIcon) && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix, PrefixIcon && /*#__PURE__*/ React.createElement(PrefixIcon, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['central-area']
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['label'], isLabelBold && s['bold-label'])
    }, label), subLabel && /*#__PURE__*/ React.createElement("div", {
        className: s['sub-label']
    }, subLabel)), (suffix || SuffixIcon) && /*#__PURE__*/ React.createElement("div", {
        className: c(s['suffix'], commonStyles['suffix'])
    }, suffix, SuffixIcon && /*#__PURE__*/ React.createElement(SuffixIcon, {
        size: IconSize.MEDIUM,
        className: c(s['suffix'], commonStyles['suffix']),
        disableDefaultColors: true
    }))), bottomSlot && /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-slot']
    }, bottomSlot));
};
ListItemContent.displayName = 'ListItemContent';
export default ListItemContent;
